import { PropertyModel } from '@modules/property/property-model';

const { fields } = PropertyModel;

export default [
  fields.id,
  fields.name,
  fields.status,
  fields.createdAt
];
